// Internal Imports (Models & Services)
// import { InsuranceDetails } from "@/api/models/Contracts";
import { ContractDetailService } from '@/api/services/contractDetailService';

// External Imports (Redux & Redux-Saga)
import { takeLatest, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';

import { EventData, InsuranceRequest } from '@/utils/types';

import {
  fetchInsuranceDetailsRequest,
  fetchInsuranceDetailsSuccess,
  fetchInsuranceDetailsFailure,
} from './insuranceDetailsSlice';

function* fetchInsuranceDetailsSaga(
  action: PayloadAction<InsuranceRequest>,
): Generator<CallEffect<EventData[]> | PutEffect, void, EventData[]> {
  try {
    // Call the API service to fetch insurance data for InsuranceDetails
    const insuranceEventsResponse: EventData[] = yield call(
      ContractDetailService.fetchInsuranceEventsList,
      action.payload,
    );

    // Dispatch success action with fetched insurance data
    yield put(fetchInsuranceDetailsSuccess(insuranceEventsResponse));
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Fetching insurance failed';
    yield put(fetchInsuranceDetailsFailure(errorMessage));
  }
}

/**
 * Watcher Saga that listens for `fetchInsuranceRequest` actions
 * and triggers `fetchInsuranceSaga` when the action is dispatched.
 */
export function* watchInsuranceEventDetails(): SagaIterator {
  yield takeLatest(fetchInsuranceDetailsRequest.type, fetchInsuranceDetailsSaga);
}
